import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { AppEnvironmentEnum } from '@lib/shared';

@Component({
	selector: 'lib-shared-version-banner',
	imports: [NgClass],
	templateUrl: './version-banner.component.html',
	styleUrl: './version-banner.component.scss'
})
export class VersionBannerComponent {
	protected readonly AppEnvironmentEnum = AppEnvironmentEnum;

	@Input({ required: true }) appEnvironment: AppEnvironmentEnum = AppEnvironmentEnum.UNKNOWN;
}
